<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    :unitText="'Cancel'"
    @next="handleNext"
    @cancel="handleCancel">
    <div class="email-dialog">
      <select-quote-type v-model="selectType"></select-quote-type>
      <div class="form-item">
        <span class="mg-b-8">Type</span>
        <v-radio-group
          v-model="type"
          block
          :list="selectSMEList"></v-radio-group>
      </div>
    </div>
  </dialog-component>
</template>

<script>
import SelectQuoteType from '@/views/components/select-quote-type'
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
export default {
  name: 'selectCreateSeverDialog',
  components: {SelectQuoteType},
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props:{
    value:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      selectType:'1',
      type:89,
      isShow:false
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Create Quote For',
        buttonRightText:'Confirm'
      }
    },
    severType(){
      return this.selectType==1?'holdcover':'fina'
    }
  },
  watch:{
    value:{
      immediate:true,
      handler(val){
        this.isShow = val
      }
    },
  },
  methods:{
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    handleCancel(){
      this.$emit('input',false)
    },
    handleNext(){
      this.setSelectCustomerData(null)
      this.setCustomerId(null)
      this.setReferCustomerId(null)
      this.setSelectReferCustomerData(null)
      this.$router.push(`/create/sme/${this.severType}/tickets/${this.type}`)
    }
  }
}
</script>

<style scoped>

</style>
